import React, { useEffect, useState, useContext } from "react";
import "./VoyahDreamHero.css";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

import LanguageSelector from "../../../LanguageSelector";

const VoyahDreamHero = () => {
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getPageContent("voyahdream", currentLang);

        // response.sections.hero
        setData(response.sections);
      } catch (err) {
        console.error("CMS load error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [currentLang]);

  if (loading) return null;
  if (error || !data) return null;

  const { hero } = data;
  const preferredOrder = ["range", "acceleration", "power"];
  const statPairsFromLabelValue = Object.keys(hero)
    .filter((k) => k.endsWith("_label"))
    .map((labelKey) => {
      const baseKey = labelKey.replace(/_label$/, "");
      const valueKey = `${baseKey}_value`;
      return {
        key: baseKey,
        label: hero[labelKey],
        value: hero[valueKey],
      };
    })
    .filter((item) => item.label && item.value)
    .sort((a, b) => {
      const ia = preferredOrder.indexOf(a.key);
      const ib = preferredOrder.indexOf(b.key);
      if (ia === -1 && ib === -1) return 0;
      if (ia === -1) return 1;
      if (ib === -1) return -1;
      return ia - ib;
    });
  const statPairsFromStatKeys = Object.keys(hero)
    .filter((k) => /^stat_\d+$/.test(k))
    .sort((a, b) => Number(a.split("_")[1]) - Number(b.split("_")[1]))
    .map((k) => String(hero[k] || "").trim())
    .filter(Boolean)
    .map((text, idx) => {
      const sepIndex = text.indexOf(":");
      if (sepIndex !== -1) {
        return {
          key: `stat_${idx + 1}`,
          label: `${text.slice(0, sepIndex).trim()}:`,
          value: text.slice(sepIndex + 1).trim(),
        };
      }
      return {
        key: `stat_${idx + 1}`,
        label: text,
        value: "",
      };
    });
  const statPairs = statPairsFromLabelValue.length
    ? statPairsFromLabelValue
    : statPairsFromStatKeys;
  const mainStats = statPairs.filter((item) => item.value);
  const singleStats = statPairs.filter((item) => !item.value);

  return (
    <section className="voyahdreamhero">

        <div className="absolute top-6 right-6 z-50">
        <LanguageSelector />
      </div>
      {/* LOGO (STATIC CSS BACKGROUND) */}
      <div className="vdlogo"></div>

      {/* STATS */}
      <div className="voyahdreamhero-stats">
        <div className="voyahdreamhero-stats-main">
          {mainStats.map((item) => (
            <div key={item.key} className="voyahdream-stat">
              <span className="voyahdream-stat-label">{item.label}</span>
              <span className="voyahdream-stat-value">{item.value}</span>
            </div>
          ))}
        </div>

        {singleStats.length > 0 && (
          <div className="voyahdreamhero-stats-single-row">
            {singleStats.map((item) => (
              <div key={item.key} className="voyahdream-stat voyahdream-stat-single-item">
                <span className="voyahdream-stat-single">{item.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default VoyahDreamHero;
